import { Component } from '@angular/core';

@Component({
    selector: 'oaj-home-itx',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css']
})
export class HomeComponent { }